export default __webpack_public_path__ + "static/media/shareTwitter.1463b10f.svg";